import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup, InputGroupText } from 'reactstrap';
import {
  isRequired,
} from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';
import Select from '../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../utils/enum';
import { CURRENCY_CODE } from '../../../../config/constants';
import { CURRENCY } from '../../../../config/locale';

export const SalesTaxForm = ({ handleSubmit, loading }) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Moneda" required={[[isRequired]]}>
          <Field
            name="currencyId"
            id="currencyId"
            component={Select}
            options={enumToSelectOptions(CURRENCY_CODE)}
            showToolTip
            placeholder="Select"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tasa" required>
          <Field
            name="rate"
            component={TextInput}
            type='number'
            validate={[isRequired]}
            placeholder="0.00"
            append={<InputGroupText>{CURRENCY}</InputGroupText>}
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.SalesTax.getIn(['current', 'activity']).isEmpty(),
});

SalesTaxForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

SalesTaxForm.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'SalesTaxForm',
})(SalesTaxForm);

export default connect(mapStateToProps)(formComponent);
